import App from '@/models/App'
import OrderingReceiverEstimateItem from '@/models/OrderingReceiverEstimateItem'
import OrderingOrdererOrder from '@/models/OrderingOrdererOrder'
import OrderingOrdererAccount from '@/models/OrderingOrdererAccount'
import OrderingOrdererOrderStatusLog from '@/models/OrderingOrdererOrderStatusLog'
import OrderingRecieverEstimateStatusLog from '@/models/OrderingReceiverEstimateStatusLog'

export default class OrderingReceiverEstimate extends App {
    static get entity() {
        return 'OrderingReceiverEstimates'
    }

    static all() {
        return this.query()
            .with(
                'orderingEstimateItems.orderingOrderItem.orderingItem.orderingItemCategory'
            )
            .with(
                'orderingEstimateItems.orderingOrderItem.orderingItem.orderingItemImages'
            )
            .with('orderingOrder.orderingOrderItems')
            .with('orderingOrder.orderingAccount.user')
            .with('lastRemandedLog')
            .get()
    }

    static find(orderingEstimateId) {
        return this.query()
            .with(
                'orderingEstimateItems.orderingOrderItem.orderingItem.orderingItemCategory'
            )
            .with(
                'orderingEstimateItems.orderingOrderItem.orderingItem.orderingItemImages'
            )
            .with('orderingOrder.orderingOrderItems')
            .with('orderingOrder.orderingAccount.user')
            .with('lastRemandedLog')
            .where('id', orderingEstimateId)
            .first()
    }

    static fields() {
        return {
            id: this.attr(''),
            orderingOrderId: this.attr(''),
            name: this.attr(''),
            number: this.attr(0),
            status: this.attr(''),
            possibleDeliveryDate: this.attr(''),
            isAbleToSpecifyDeliveryTime: this.attr(false),
            postage: this.attr(0),
            discountType: this.attr(''),
            discountPercentage: this.attr(0.0),
            discountYen: this.attr(0),
            reasonForRemand: this.attr(''),
            createdAt: this.attr(''),
            updatedAt: this.attr(''),
            orderingEstimateItems: this.hasMany(
                OrderingReceiverEstimateItem,
                'orderingEstimateId'
            ),
            orderingOrder: this.belongsTo(
                OrderingOrdererOrder,
                'orderingOrderId'
            ),
            lastRemandedLog: this.hasOne(
                OrderingRecieverEstimateStatusLog,
                'orderingEstimateId'
            ),
        }
    }

    static apiConfig = {
        actions: {
            fetch(params) {
                return this.get(`/ordering/receiver/estimates`, {
                    params: App.get(params),
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    dataKey: 'data',
                    baseURL: App.apiURL(),
                })
            },
            find(orderingEstimateId, params) {
                return this.get(
                    `/ordering/receiver/estimates/${orderingEstimateId}`,
                    {
                        params: App.get(params),
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        dataKey: 'data',
                        baseURL: App.apiURL(),
                    }
                )
            },
            update(orderingEstimateId, params) {
                params = { ...params }
                if (params.hasOwnProperty('isAbleToSpecifyDeliveryTime')) {
                    params.isAbleToSpecifyDeliveryTime =
                        params.isAbleToSpecifyDeliveryTime ? 1 : 0
                }
                return this.patch(
                    `/ordering/receiver/estimates/${orderingEstimateId}`,
                    App.patch(params),
                    {
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        baseURL: App.apiURL(),
                    }
                )
            },
            updateItem(orderingEstimateId, orderingEstimateItemId, params) {
                params = { ...params }
                params.isNotAcceptable = params.isNotAcceptable ? 1 : 0
                return this.patch(
                    `/ordering/receiver/estimates/${orderingEstimateId}/items/${orderingEstimateItemId}`,
                    App.patch(params),
                    {
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        baseURL: App.apiURL(),
                    }
                )
            },
            submit(orderingEstimateId, params) {
                return this.patch(
                    `/ordering/receiver/estimates/${orderingEstimateId}/submit`,
                    App.patch(params),
                    {
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        baseURL: App.apiURL(),
                    }
                )
            },
            cancel(orderingEstimateId, params) {
                return this.patch(
                    `/ordering/receiver/estimates/${orderingEstimateId}/cancel`,
                    App.patch(params),
                    {
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        baseURL: App.apiURL(),
                    }
                )
            },
            ship(orderingEstimateId, params) {
                return this.patch(
                    `/ordering/receiver/estimates/${orderingEstimateId}/ship`,
                    App.patch(params),
                    {
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        baseURL: App.apiURL(),
                    }
                )
            },
        },
    }
}
